import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The lead pool is gone (ADR 0019, spec 071): every entry opens its opportunity, so old links
 * and bookmarks land on the pipeline.
 */
export const Route = createFileRoute('/_app/leads/')({
  beforeLoad: () => {
    throw redirect({ to: '/deals', search: {}, replace: true });
  },
});
